export default __webpack_public_path__ + "static/media/user-circle.40fe8b7d.svg";